import { Link } from "react-router-dom";
import { X, Plus, Minus } from "lucide-react";
import { useCart } from "@/context/CartContext";

export function CartDrawer() {
  const { open, setOpen, items, updateQty, removeItem, subtotal } = useCart();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-ink/50" onClick={() => setOpen(false)} data-testid="cart-overlay" />
      <aside className="absolute right-0 top-0 h-full w-full max-w-md bg-paper border-l border-ink/15 flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-ink/15">
          <p className="font-college text-2xl">CART</p>
          <button data-testid="cart-close-button" onClick={() => setOpen(false)} aria-label="Close cart">
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {items.length === 0 ? (
            <p className="text-ink/60 text-sm mt-6" data-testid="cart-empty-message">
              Nothing in here yet. Pick something up and keep it for a long time.
            </p>
          ) : (
            <ul className="space-y-4">
              {items.map((item) => (
                <li key={item.key} className="flex gap-4 border-b border-ink/20 pb-4" data-testid={`cart-item-${item.slug}`}>
                  <div className="w-20 h-20 bg-white shrink-0">
                    <img src={item.image} alt={item.name} className="w-full h-full object-contain p-1" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between gap-2">
                      <p className="font-college text-navy leading-tight">{item.name}</p>
                      <button data-testid={`cart-remove-${item.slug}`} onClick={() => removeItem(item.key)} aria-label="Remove">
                        <X size={16} />
                      </button>
                    </div>
                    <p className="text-xs text-ink/60 mt-0.5">SIZE: {item.size}</p>
                    <div className="flex items-center justify-between mt-2">
                      <div className="flex items-center">
                        <button data-testid={`cart-minus-${item.slug}`} onClick={() => updateQty(item.key, -1)} className="px-2 py-1" aria-label="Decrease">
                          <Minus size={14} />
                        </button>
                        <span className="px-2 text-sm font-semibold" data-testid={`cart-qty-${item.slug}`}>{item.quantity}</span>
                        <button data-testid={`cart-plus-${item.slug}`} onClick={() => updateQty(item.key, 1)} className="px-2 py-1" aria-label="Increase">
                          <Plus size={14} />
                        </button>
                      </div>
                      <p className="font-semibold">${item.price * item.quantity}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {items.length > 0 && (
          <div className="border-t border-ink/15 px-5 py-4">
            <div className="flex justify-between mb-1">
              <span className="text-sm text-ink/70">Subtotal</span>
              <span className="font-semibold" data-testid="cart-subtotal">${subtotal}</span>
            </div>
            <p className="text-xs text-ink/50 mb-4">Shipping added at checkout.</p>
            <Link
              to="/checkout"
              onClick={() => setOpen(false)}
              data-testid="cart-checkout-button"
              className="block text-center bg-navy text-paper font-college text-xl py-3 shadow-print hover:bg-red transition-colors"
            >
              CHECKOUT
            </Link>
          </div>
        )}
      </aside>
    </div>
  );
}
